var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLithuania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.2 41.223)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41.17 40.234)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e7a50c",
    d: "M-963.02 158.54v-240l400 .003h400v480h-800v-240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa1f33",
    d: "M-963.02 238.54v-160l400 .003h400v320h-800v-160z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d593e",
    d: "M-963.02 158.54V78.543h800V238.54h-800v-80z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLithuania);
export default __webpack_public_path__ + "static/media/lithuania.123de50b720bad69ec89694c6bd62061.svg";
export { ForwardRef as ReactComponent };